import { Navigate, useParams } from 'react-router';

import { type Category, CategoryView } from './CategoryView';
import { NoteGroupCategory } from './NoteGroupCategory';

const CATEGORIES: readonly Category[] = [
  'boards',
  'team-boards',
  'workspaces',
  'databases',
  'favorites',
];

/** `/app/browse/:category`: the full-screen category view. */
export function CategoryPage() {
  const { category } = useParams();
  const known = CATEGORIES.find((value) => value === category);
  if (category === 'documents' || category === 'groups')
    return <NoteGroupCategory category={category} />;
  if (!known) return <Navigate to="/app" replace />;
  return <CategoryView category={known} />;
}
